import '@angular/compiler';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalKioskPrintComponent } from './portal.kiosk.print/portal.kiosk.print.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalKioskCreateComponent } from './portal.kiosk.create/portal.kiosk.create.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalKioskCameraComponent } from './portal.kiosk.camera/portal.kiosk.camera.component';
import { PortalKioskMapComponent } from './portal.kiosk.map/portal.kiosk.map.component';
import { PortalKioskPreparingComponent } from './portal.kiosk.preparing/portal.kiosk.preparing.component';
import { PagePicComponent } from './page.pic/page.pic.component';
import { PortalKioskQuizComponent } from './portal.kiosk.quiz/portal.kiosk.quiz.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { ComponentCardComponent } from './component.card/component.card.component';
import { PortalKioskFinishComponent } from './portal.kiosk.finish/portal.kiosk.finish.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { PortalKioskScoreComponent } from './portal.kiosk.score/portal.kiosk.score.component';
import { PortalKioskCharacterComponent } from './portal.kiosk.character/portal.kiosk.character.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalKioskResultComponent } from './portal.kiosk.result/portal.kiosk.result.component';

const INDEX_PAGE = "main";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "main/:mode?",
                component: PageMainComponent,
                "app_id": "page.main"
            },
            {
                "path": "pic/:session_id?",
                component: PagePicComponent,
                "app_id": "page.pic"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }